import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=785968ed&"
import script from "./ProductSearch.vue?vue&type=script&lang=js&"
export * from "./ProductSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports